import {Template} from './Template.js';

export class Quilter extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Template(`Quilter`);
	}
	connectedCallback() {
		if (0==this.childElementCount) {
			this.appendChild(this.el);

			const quill = new Quill(this.$.editor, {
				 theme: 'snow'
			});
		}
	}
}
customElements.define(`boards-quilter`, Quilter);